import { render } from "./ComingSoon.vue?vue&type=template&id=32880663&scoped=true"
import script from "./ComingSoon.vue?vue&type=script&lang=js"
export * from "./ComingSoon.vue?vue&type=script&lang=js"

import "./ComingSoon.vue?vue&type=style&index=0&id=32880663&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-32880663"

export default script